import React from "react"

export default function Denied() {
  return (
    <div className="homepage">
      <h1>Access Denied</h1>
    </div>
  )
}
